<div *ngIf="validationCheck" tabindex="-1" style="display: block;">
    <div class="modal-dialog" role="document" style="width: 47vw;">
        <div class="modal-content">
            <div class="fullscreen">
                <div class="modal-body" style="height: 30vh; overflow-y: auto;">
                    <div class="mt-4" style="text-align: center;">
                        <h6> This MNO Map is used by one or more groups.</h6>
                        <h6>If you wish to edit or delete the MNO Map, first remove it from all the groups where it's
                            currently added to.</h6>
                        <h6>Do you want to proceed with groups edit?</h6>
                        <div class="mt-4">
                            <button type="button" class="btn btn-danger" style="margin-right: 1rem; width: 75px;"
                                (click)="onCancel(content)">
                                Cancel</button>
                            <button type="button" class="btn btn-primary" style="margin-right: 1rem; width: 200px;" (click)="redirectToGroupManager()">
                                Proceed to Groups
                                Manager</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="validationCheck == false" class="modal fade show" role="dialog" tabindex="-1"
    style="display: block; width:100%; min-width: 80vw;">
    <div class="modal-dialog" role="document" style="min-width: 80vw;">
        <div class="modal-content">
            <div class="modal-header">
                <h5 id="exampleModalLongTitle">{{title}}</h5>
                <button type="button" class="close" (click)="onCancel(content)" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            
            <div class="modal-body">
                <div *ngIf="isSpinner">
                    <div id="global-loader">
                        <img src="./assets/img/loaders/loader.svg" class="loader-img" alt="Loader">
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <!-- <div class="card"> -->
                        <div class="card-body">
                            <div class="row">
                                <div class="col-lg-3 pr-1">
                                    <div class="card p-3 mb-0 cls_pb-12" >
                                        <!-- <h4>Filters</h4> -->
                                        <span class="ag-header-cell-resize" unselectable="on"
                                            role="presentation"></span>
                                            <div class="mb-1">
                                        <label for="MNO Map" class="text-muted mb-0"><strong>MNO Map</strong>
                                            <span class="ms-2" style="color: red; font-size: 20px;">*</span></label>
                                        <input type="text" class="form-control" [(ngModel)]="setMNOMapName" (keypress)="validateName($event);" (ngModelChange)="onsetMNOMapName();" placeholder="Enter MNO Map"
                                            >
                                        </div><div class="mb-1">
                                        <label for="MNO Map" class="text-muted mb-0"><strong>Region</strong>
                                            <span class="ms-2" style="color: red; font-size: 20px;">*</span></label>
                                            <ng-select  [appendTo]="'body'" [items]="regionsList" [searchable]="true" [(ngModel)]="selectedRegion" name="Regions"
                                            placeholder="Select Region" (change)="onRegionChange($event, newMono); changeEvent();">
                                        </ng-select>
                                    </div><div class="mb-1">
                                        <label for="MNO Map" class="text-muted mb-0"><strong>MNO</strong>
                                            <span class="ms-2" style="color: red; font-size: 20px;">*</span></label>
                                            <ng-select [appendTo]="'body'" [items]="mnosList" [searchable]="true" [(ngModel)]="selectedMno" bindLabel="mno" bindValue="mno"
                                            placeholder="Select MNO" (change)="onMnoChange($event, newMono); changeEvent();">
                                            <ng-option *ngFor="let car of mnosList" [value]="car.mno">{{car.mno}}</ng-option>
                                        </ng-select>
                                    </div><div class="mb-1">
                                        <label for="MNO Map"class="text-muted mb-0"><strong>4G Bands</strong>
                                            <span class="ms-2" style="color: orange; font-size: 20px;">*</span></label>
                                            <ng-select [appendTo]="'body'" [items]="fourGbandsList" [searchable]="true" [multiple]="true" [(ngModel)]="selectedFourG" name="Bands" bindLabel="mno" bindValue="mno"
                                            placeholder="Select 4G Bands" (change)="onFourgChange($event); changeEvent();">                                       
                                        </ng-select>
                                    </div><div class="mb-1">
                                        <label for="MNO Map" class="text-muted mb-0"><strong>5G Bands</strong>
                                            <span class="ms-2" style="color: orange; font-size: 20px;">*</span></label>
                                            <ng-select [appendTo]="'body'" [items]="fiveGbandsList" [searchable]="true" [multiple]="true" [(ngModel)]="selectedFiveG" name="5GBands"
                                            placeholder="Select 5G Bands" (change)="onFivegChange($event); changeEvent();"></ng-select>
                                        
                                        </div><div class="mb-1">
                                                <label class="text-muted mb-0"
                                            style="font-weight: 600;  float: left; width: 100%; margin-top: 5px;">NSA
                                            5G Bands<span class="ms-2" style="color: orange; font-size: 20px;">*</span>
                                        </label>
                                        <ng-select [appendTo]="'body'" [items]="nsafiveGbandsList" [searchable]="true" [multiple]="true" [(ngModel)]="selectedNsaFiveG" name="NSA5GBands"
                                            placeholder="Select NSA 5G Bands" (change)="onNsaFivegChange($event); changeEvent();"></ng-select>
                                    </div>
                                    </div>
                                </div>
                                <div class="col-lg-9 pl-1">
                                    <div class="card p-2 mb-0">
                                        <app-geocode-map height="447px" [address]="setDisplayRegion" [selectedRegion]="selectedRegion" (markerClickEvent)="markerClickEvent($event)" ></app-geocode-map>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- </div> -->
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <div style="width: 70%">
                    <p class="text-center text-warning" >{{message}}</p>
                    <p class="text-center text-danger" >{{error}}</p>
                </div>
                <button type="button" class="btn btn-danger width75" data-dismiss="modal" (click)="onCancel(content)">Close</button>
                <button type="button" class="btn btn-primary width75" [disabled]="enableButton" (click)="submitMno()">Save</button>
            </div>
        </div>
    </div>
</div>
<ng-template #content let-modal>
	
	<div class="modal-body">
        <div class="mt-4" style="text-align: center">
            <h5>You haven't saved the data, do you want to discard it?</h5>           
	</div>
    </div>
	<div class="modal-footer">
		<button type="button" class="btn btn-danger width75"  (click)="modal.close('Save click')">Cancel</button>
		<button type="button" class="btn btn-primary width75" (click)="modal.close('Save click'); onCancel('')">Yes</button>

	</div>
</ng-template>
<ng-template #newMono let-modal>
    <div class="modal-header">
        <h3 *ngIf="disabledRegionInput">Add New MNO</h3>
        <h3 *ngIf="!disabledRegionInput">Add New Region & MNO</h3>

    </div>
    <div class="modal-body" >        
        <form (ngSubmit)="createNewMno()" #mnoForm="ngForm">
            <div style="height: 70vh; overflow-y: auto;">
                <div class="mb-1">
                    <label for="region" class="text-muted mb-0"><strong>Region</strong>
                        <span class="ms-2" style="color: red; font-size: 20px;">*</span></label>
                    <input type="text" class="form-control" id="region" [(ngModel)]="newMno.region" [disabled]="disabledRegionInput" name="region" required placeholder="Enter Region" (ngModelChange)="newRegionChange($event)" />
                    
                    <ul *ngIf="filteredOptions.length > 0 && newMno.region" class="autocomplete-list theme_background color_theme ">
                        <li
                              *ngFor="let country of filteredOptions"
                              (click)="selectCountry(country)"
                              class="autocomplete-item"
                        >
                              {{ country }}
                        </li>
                        </ul>
                        <div *ngIf="mnoForm.controls.region?.invalid && (mnoForm.controls.region?.touched || mnoForm.submitted)" class="text-danger">
                        Region is required.
                    </div>
                </div>
            <div class="mb-1">
                <label for="mno" class="text-muted mb-0"><strong>MNO</strong>
                    <span class="ms-2" style="color: red; font-size: 20px;">*</span></label>
                <input type="text" class="form-control" id="mno" [(ngModel)]="newMno.mno" name="mno" required placeholder="Enter Mno" (ngModelChange)="newMnoChange()" />
                <div *ngIf="mnoForm.controls.mno?.invalid && (mnoForm.controls.mno?.touched || mnoForm.submitted)" class="text-danger">
                    MNO is required.
                </div>
                <div *ngIf="uniqueError">
                <p class="text-danger" >{{uniqueError}}</p>
            </div>
            </div>
            <div class="mb-1">
                <label class="text-muted mb-0">MCC:<span class="ms-2" style="color: red; font-size: 20px;">*</span></label>
                <mat-form-field class="band-chip-list" appearance="fill">
                    <mat-chip-list #chipListMcc>
                        <mat-chip *ngFor="let code of newMno.mcc" [selectable]="true" [removable]="true" (removed)="removeCode('mcc', code)">
                            {{ code }}
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
                        <input  id="mcc" name="mcc" [(ngModel)]="mccInput"  #mcc="ngModel"
                            placeholder="Add MCC codes (numbers only)..."
                            [matChipInputFor]="chipListMcc"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                            [matChipInputAddOnBlur]="true"
                            (matChipInputTokenEnd)="addCode('mcc', $event)"
                            matInput
                            required
                            (keypress)="allowOnlyNumbers($event)"
                            (paste)="handlePaste('mcc', $event)"
                        />
                    </mat-chip-list>
                </mat-form-field>
                <div *ngIf="(mcc.touched || mnoForm.submitted) && !newMno.mcc.length" class="text-danger">
                    MCC is required and must contain at least one valid number.
                  </div>
            </div>
            
            <!-- Dynamic MNC -->
            <div class="mb-1">
                <label class="text-muted mb-0">MNC:<span class="ms-2" style="color: red; font-size: 20px;">*</span></label>
                <mat-form-field class="band-chip-list" appearance="fill">
                    <mat-chip-list #chipListMnc>
                        <mat-chip *ngFor="let code of newMno.mnc" [selectable]="true" [removable]="true" (removed)="removeCode('mnc', code)">
                            {{ code }}
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
                        <input id="mnc" name="mnc" [(ngModel)]="mncInput" #mnc="ngModel"
                            placeholder="Add MNC codes (numbers only)..."
                            [matChipInputFor]="chipListMnc"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                            [matChipInputAddOnBlur]="true"
                            (matChipInputTokenEnd)="addCode('mnc', $event)"
                            matInput
                            required
                            (keypress)="allowOnlyNumbers($event)"
                            (paste)="handlePaste('mnc', $event)"
                        />
                    </mat-chip-list>
                </mat-form-field>
                <div *ngIf="(mnc.touched || mnoForm.submitted) && !newMno.mnc.length" class="text-danger">
                    MNC is required and must contain at least one valid number.
                  </div>
            </div>
            <!-- Dynamic 4G Bands -->
            <div class="mb-1">
                <label class="text-muted mb-0">4G Bands:<span class="ms-2" style="color: orange; font-size: 20px;">*</span></label>
                <mat-form-field class="band-chip-list" appearance="fill">
                    <mat-chip-list #chipList4G>
                        <mat-chip *ngFor="let band of newMno.bands4G" [selectable]="true" [removable]="true" (removed)="removeBand('4G', band)">
                            {{ band }}
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
                        <input 
                            placeholder="Add 4G bands (numbers only)..."
                            [matChipInputFor]="chipList4G"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                            [matChipInputAddOnBlur]="true"
                            (matChipInputTokenEnd)="addBand('4G', $event)"
                            (paste)="pasteBands('4G', $event)"
                            matInput
                            (keypress)="allowOnlyNumbers($event)"
                        />
                    </mat-chip-list>
                </mat-form-field>
            </div>
            <!-- Dynamic 5G Bands -->
            <div class="mb-1">
                <label class="text-muted mb-0">5G Bands:<span class="ms-2" style="color: orange; font-size: 20px;">*</span></label>
                <mat-form-field class="band-chip-list" appearance="fill">
                    <mat-chip-list #chipList5G>
                        <mat-chip *ngFor="let band of newMno.bands5G" [selectable]="true" [removable]="true" (removed)="removeBand('5G', band)">
                            {{ band }}
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
                        <input 
                            placeholder="Add 5G bands (numbers only)..."
                            [matChipInputFor]="chipList5G"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                            [matChipInputAddOnBlur]="true"
                            (matChipInputTokenEnd)="addBand('5G', $event)"
                            (paste)="pasteBands('5G', $event)"
                            matInput
                            (keypress)="allowOnlyNumbers($event)"
                        />
                    </mat-chip-list>
                </mat-form-field>
            </div>
            <!-- Dynamic NSA 5G Bands -->
            <div class="mb-1">
                <label class="text-muted mb-0">NSA 5G Bands:<span class="ms-2" style="color: orange; font-size: 20px;">*</span></label>
                <mat-form-field class="band-chip-list" appearance="fill">
                    <mat-chip-list #chipListNsa5G>
                        <mat-chip *ngFor="let band of newMno.bandsNsa5G" [selectable]="true" [removable]="true" (removed)="removeBand('Nsa5G', band)">
                            {{ band }}
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
                        <input 
                            placeholder="Add NSA 5G bands (numbers only)..."
                            [matChipInputFor]="chipListNsa5G"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                            [matChipInputAddOnBlur]="true"
                            (matChipInputTokenEnd)="addBand('Nsa5G', $event)"
                            (paste)="pasteBands('Nsa5G', $event)"
                            matInput
                            (keypress)="allowOnlyNumbers($event)"
                        />
                    </mat-chip-list>
                </mat-form-field>
            </div>
            <!-- Submit and Close buttons -->
           
            </div>
            <hr>
            <p class="text-center text-warning" >{{errormessage}}</p>

            <div class="popup-actions">
                
                
                <button type="submit"class="btn btn-primary width75" [disabled]="mnoForm.invalid || enableSaveButton">Save</button>
                <button type="button" class="btn btn-danger width75" (click)="closeModal()" >Cancel</button>
            </div>
        </form>
    </div>

</ng-template>


  
  
  


